var map = {
	"./1.svg": "90c1",
	"./2.svg": "630f",
	"./3.svg": "7bed",
	"./Vector-1.svg": "3c3f",
	"./Vector.svg": "f51a",
	"./background.svg": "0581",
	"./con_ex_mark.svg": "f0b9",
	"./error.svg": "7314",
	"./icon-calendar.svg": "c4e4",
	"./icon-call-2.svg": "2e4e",
	"./icon-call-blue.svg": "593e",
	"./icon-call.svg": "fb9e",
	"./icon-file.svg": "f25f",
	"./icon-marker.svg": "ac11",
	"./icon-person.svg": "b335",
	"./icon-phone.svg": "1763",
	"./icon-route-gray.svg": "81f0",
	"./icon-route.svg": "543c",
	"./icon-vip.svg": "7dcd",
	"./icon-zaliczka.svg": "2bec",
	"./icon_add.svg": "0c16",
	"./icon_alarm.svg": "b526",
	"./icon_down.svg": "6e82",
	"./icon_hamburger.svg": "da92",
	"./icon_incorrect_number.svg": "331e",
	"./icon_incorrect_phone_red.svg": "c81f",
	"./icon_menu.svg": "465e",
	"./icon_offline.svg": "aaf1",
	"./icon_passenger+.svg": "ef06",
	"./icon_passenger_taken.svg": "0baf",
	"./icon_phone.svg": "f90c",
	"./icon_phone_green.svg": "645f",
	"./icon_phone_locked.svg": "a5d9",
	"./icon_red_eye.svg": "f7de",
	"./icon_search.svg": "e2b9",
	"./icon_success_tick.svg": "22f8",
	"./icon_take.svg": "d9af",
	"./icon_take_gray.svg": "7755",
	"./icon_taken_red.svg": "06c4",
	"./icon_tick_gray.svg": "02a5",
	"./icon_tick_green.svg": "fc8f",
	"./icon_tick_red.svg": "45c3",
	"./icon_up.svg": "d4c9",
	"./icon_wallet.svg": "f97f",
	"./icon_wallet_black.svg": "c207",
	"./icon_warning.svg": "1518",
	"./logo.svg": "e347",
	"./logo_color.svg": "7773",
	"./ticket.svg": "60c7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";